import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { createQuerySubscriptions } from 'src/api/queries';
import { MembersPage } from 'src/apps/manageSubscription/app/pages/MembersPage';
import { subscriptionHelpers } from 'src/utils/subscriptionHelpers';

const subscriptionMembersSearchSchema = z.object({
  invite_by: z.enum(['email', 'link', 'import']).optional(),
});

export const Route = createFileRoute('/_auth/_layout/subscriptions/members')({
  validateSearch: zodValidator(subscriptionMembersSearchSchema),
  async beforeLoad({ context }) {
    const subscription = await context.queryClient.ensureQueryData(
      createQuerySubscriptions()
    );

    if (
      !subscriptionHelpers.isManagementTypeSeats(subscription) ||
      !subscription.access.canSeeMembers
    ) {
      throw redirect({ to: '/subscriptions/plan' });
    }
  },
  component: () => <MembersPage />,
});
